module.exports = __webpack_public_path__ + "static/plane-vertical-c7bf83a9ceac555d9484d44e528d0d30.png";